<div class="contributors__container padding-m">
    <h4 class="margin-bottom-m">Team contributions</h4>

    <a [href]="baseUrl"
        ><nw-side-menu-child
            class="contributors__container__all margin-bottom-m"
            label="All team contributors"
            [active]="allActive"
        ></nw-side-menu-child>
    </a>

    @for (contributor of authors; track $index) {
        <a [href]="contributor.url">
            <nw-side-menu-child
                class="contributors__container__item"
                [class.margin-bottom-m]="!$last"
                [active]="contributor.active"
                [dynamic]="contributor.dynamic"
            ></nw-side-menu-child>
        </a>
    }
</div>
